import { createAction } from '@reduxjs/toolkit';
import { SET_IS_NIF_NUMBER_SHOWED } from './actionTypes';
export const setNIFNumberShowed = createAction(SET_IS_NIF_NUMBER_SHOWED);
export const actions = {
    setNIFNumberShowed,
};
